import * as React from "react";

import "./payment-parts.scss";

import {cs}           from "@Common/react/chain-services";
import {formatMoney1} from "@Common/ui-components/language/format-money";

export const PaymentParts = ({payments}:{
    payments    : Array<{type: string, label: string, value: number}>
}) => cs(
    () => (
        <div className="payment-parts payment-parts-06c">
            {payments.map((payment, j) => (
                <div className="payment" key={j}>
                    <div className="left">
                        <div className="type">
                            {payment.type}
                        </div>
                        <div className="label" xd-qa-type="label" xd-qa-name={`${payment.type} Name`}>
                            {payment.label}
                        </div>
                    </div>

                    <div className="right" xd-qa-type="label" xd-qa-name={`${payment.type} Value`}>
                        {formatMoney1(payment.value)}
                    </div>
                </div>
            ))}
        </div>
    ),
);
